export default __webpack_public_path__ + "static/media/3026238-removebg-preview.cdb20de1.png";